<script setup lang="ts">
import { ButtonNormal } from "lorga-ui";

const click = () => window.print();
</script>
<template>
  <ButtonNormal kind="action" @click="click">Dispoplan Drucken</ButtonNormal>
</template>
